import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLEnumType
} from 'graphql'
import { orderDirection, OrderDirection } from './order-direction'

export type LibraryUsageOrderField = 'LAST_SEEN' | 'FIRST_SEEN' | 'NAME'

export const libraryUsageOrderFieldType = new GraphQLEnumType({
  name: 'LibraryUsageOrderField',
  description: 'Directions to sort a list of library class usage items',
  values: {
    NAME: {
      description: 'Order library class usage data alphabetically by name'
    },
    LAST_SEEN: {
      description: 'Order library class usage data by last seen'
    },
    FIRST_SEEN: {
      description: 'Order library class usage data by first seen'
    }
  }
})

export interface LibraryUsageOrder {
  readonly field: LibraryUsageOrderField
  readonly direction: OrderDirection
}

export const libraryUsageOrderType = new GraphQLInputObjectType({
  name: 'LibraryUsageOrder',
  description: 'Ways in which a list of library usage items can be ordered',
  fields: () => ({
    field: {
      description: 'The field to order the results by',
      type: new GraphQLNonNull(libraryUsageOrderFieldType)
    },
    direction: {
      description: 'The direction in which to order the results',
      type: new GraphQLNonNull(orderDirection)
    }
  })
})
